

import { ThemeOptions } from '@mui/material/styles';

const DefaultThemeOptions: ThemeOptions = {
    palette: {
        primary: {
            main: '#56287B'
        },
        secondary: {
            main: '#EC008C'
        },
        info: {
            light: '#76CED9',
            main: '#76CED9',
            dark: '#34bdcf'
        },
        success: {
            light: '#40e690',
            // main: '#27DFD1',
            main: '#40e690',
            dark: '#02d14e'
        },
        warning: {
            light: '#ed9821',
            main: '#ed9821',
            dark: '#de9133'
        },
        error: {
            light: '#f7a6cb',
            main: '#f5695f',
            dark: '#DB0065'
        }
    },
    typography: {
        h1: {
            fontSize: '3rem'
        },
        h2: {
            fontSize: '2.0rem',
            fontWeight: '400',
        },
        h3: {
            fontSize: '1.25rem'
        },
        h4: {
            fontSize: '1.20rem',
        },
        h5: {
            fontSize: '1.15rem',
        },
        h6: {
            fontSize: '1.10rem',
        },
        body1: {
            fontSize: '1.0rem',
            fontWeight: '500'
        },
        body2: {
            fontSize: '0.9rem',
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1250,
            xl: 1536,
        }
    }
}

export default DefaultThemeOptions